import { useState, useRef } from 'react';
export default function useBoundingBoxState(){

  const [ box, setState ] = useState();
  const ref = el => {

    if( el ){
      let parentRect = el.getBoundingClientRect();
      let parentBoxToSet = {
        width:parentRect.width,
        left:parentRect.left,
        height:parentRect.height,
        top:parentRect.top
      }



      let newPB = JSON.stringify(parentBoxToSet);
      let curPB = JSON.stringify(box);

      if( !box || (newPB !== curPB) ){
        setState(parentBoxToSet)
      }
    }
  }

  return [ box, ref ];


}


